import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class MovementHistoryService extends BaseService{
	constructor() {
		super('/MovementHistory');
	}

	public getAllByFilter(filter: MovementHistoryFilter) {
		return super.getAllByFilterBase(filter);
	}	
}

export class MovementHistoryFilter extends BaseFilter{
	constructor(idMovement?: number   ) {
		super();
		this._idMovement = idMovement;
	}

	private _idMovement?: number ;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idMovement != 0 ? { IdMovement: this._idMovement } : {})

		);
		
		return data;
	};
}
